import type { BaseOption } from '@/components/ui/select-v2'

export const createDateOptions = (t: (key: string) => string): BaseOption[] => [
  {
    label: t('last_7_days'),
    value: 7,
  },
  {
    label: t('last_14_days'),
    value: 14,
  },
  {
    label: t('last_30_days'),
    value: 30,
  },
]

export const coreMetrics = ['visitors', 'pageviews']
